'use client';

import * as React from 'react';

export const useIntersect = ({
  root,
  rootMargin,
  threshold,
  deps,
}: {
  root: Element | null;
  rootMargin: string;
  threshold: number[];
  deps?: React.DependencyList;
}) => {
  const node = React.useRef<HTMLDivElement>(null);
  const [entry, updateEntry] = React.useState<IntersectionObserverEntry | null>(null);

  if (typeof window !== 'undefined') {
    const observer = React.useRef(
      new window.IntersectionObserver(
        ([e]) => {
          updateEntry(e);
        },
        {
          root,
          rootMargin,
          threshold,
        },
      ),
    );

    React.useEffect(() => {
      const { current: currentObserver } = observer;
      currentObserver.disconnect();

      const n = node.current;
      if (n) {
        currentObserver.observe(n);
      }

      return () => {
        currentObserver.disconnect();
      };
    }, [node, ...(deps || [])]);
  }

  return {
    node,
    entry,
  };
};
